export default __webpack_public_path__ + "static/media/original-preview3.eda5b7c4.gif";